module.exports = "//public.zight.com/packs/media/images/2-da93033d71f1ce361ecaa47655aae16d.png";